import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import KalixaReturnPage from './KalixaReturnPage';

const KalixaReturnRoute: FuseRouteItemType = {
    path: 'payment/kalixa/:status',
    element: <KalixaReturnPage />,
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false
                },
                toolbar: {
                    display: false
                },
                footer: {
                    display: false
                },
                leftSidePanel: {
                    display: false
                },
                rightSidePanel: {
                    display: false
                }
            }
        }
    }
};

export default KalixaReturnRoute;
